import { NoStoreNoTransactionDto } from './no-store-no-transaction.dto';
import { IdentityDto } from './../shared/identity.dto';
import { CapabilityDto } from './../shared/capability.dto';
import { EntityDto } from './../entity';
import { NetworkSettingDto } from './network-setting.dto';

export class MerchantIdentifierDto {
  identity: IdentityDto;
  entity: EntityDto;
  voidSupportMode: string;
  businessGroup: string;
  acquirer: string;
  tenant: string;
  merchantCategoryCode: string;
  merchantCapabilities: CapabilityDto[];
  noStoreNoTransaction: NoStoreNoTransactionDto;
  networkSettings: NetworkSettingDto[];
  merchantName: string;

  constructor(d?: MerchantIdentifierDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);

    this.identity = new IdentityDto(d.identity);
    this.entity = new EntityDto(d.entity);
    this.networkSettings = d.networkSettings
      ? d.networkSettings.map(i => new NetworkSettingDto(i))
      : [];
  }
}
